import {
  ICreateMeetingFolder,
  ICreateMeetingShortcut,
  IDeleteMeetingShortcut,
  IUpdateMeetingShortcut,
} from '../../resource/meeting-shortcuts/meeting-shortcuts.types';
import { IApiRequestConfig } from '../api.types';

export const createShortcutFolderApi = ({
  meetingId,
  name,
  parentId,
}: ICreateMeetingFolder): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createFileFolder',
  uri: 'json',
  action: `meetings/${meetingId}/file-folders`,
  method: 'post',
  data: {
    name,
    parent_id: parentId,
  },
  v2: true,
});

export const createShortcutFolderFileApi = ({
  meetingId,
  externalLink,
  description,
  folderId,
  name,
}: ICreateMeetingShortcut): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createFileFolderFile',
  action: `meetings/${meetingId}/files`,
  uri: 'json',
  method: 'post',
  data: {
    files: [
      {
        externalLink,
        description,
        folderId,
        name,
      },
    ],
  },

  v2: true,
});

export const updateShortcutFolderFileApi = ({
  shortcutId,
  meetingId,
  externalLink,
  description,
  name,
}: IUpdateMeetingShortcut): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateMeetingShortcut',
  action: `meetings/${meetingId}/files/${shortcutId}`,
  uri: 'json',
  method: 'patch',
  data: {
    externalLink,
    description,
    name,
  },

  v2: true,
});

export const deleteShortcutFolderFileApi = ({
  shortcutId,
  meetingId,
}: IDeleteMeetingShortcut): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateMeetingShortcut',
  action: `meetings/${meetingId}/files/${shortcutId}`,
  uri: 'json',
  method: 'delete',
  v2: true,
});

export const getShorcutFoldersApi = (meetingId: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getFileFolders',
  uri: 'json',
  action: `meetings/${meetingId}/file-folders`,
  method: 'get',
  v2: true,
});

export const getShortcutFolderApi = (meetingId: string, fileFolderId: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getFileFolder',
  uri: 'json',
  action: `meetings/${meetingId}/file-folders/${fileFolderId}`,
  method: 'get',
  v2: true,
});

export const deleteShortcutFolderApi = (meetingId: string, fileFolderId: string): IApiRequestConfig<unknown> => ({
  action: 'deleteFileFolder',
  apiRouteKey: 'deleteFileFolder',
  uri: `meetings/${meetingId}/file-folders/${fileFolderId}`,
  method: 'delete',
  v2: true,
});
